import * as $ from 'jquery';
import * as _ from 'lodash';
import { Util } from '../util';
import { ProgressTimerOptions } from './components';
import { ProgressBar, ProgressBarOptions } from './progressBar';




/**
 * ProgressTimerで実装するとタイムラグがかなりあるので、固有実装
 */
export class ProgressTimeSpan extends ProgressBar {

    private nIntervId;
    private interval: number;

    private startDateTime: Date;
    private endDateTime: Date;

    public onTick: (current: number) => number;
    public onAt25: () => void;
    public onAt50: () => void;
    public onAt75: () => void;
    public onTimeOut: () => void;

    //private now: Date;
    private get now(): Date {
        //都度最新
        return new Date();
    };

    /***/
    get nowMilliseconds() {
        //return this.now.getMilliseconds();
        return this.now.getTime();

    };
    /***/
    get startDateMilliseconds(): number {
        return (Util.date.isDate(this.startDateTime)) ? this.startDateTime.getTime() : 0;
    };

    /***/
    get endDateMilliseconds(): number {
        return (Util.date.isDate(this.endDateTime)) ? this.endDateTime.getTime() : 0;
    };


    /***/
    get ToTalSecond() {
        //定義をそのまま使用する場合は下記（validDateTimeが仮に存在しないカラムの場合）
        //return this.TimeoutMinutes;
        //開始から終了までの差
        let interval = this.endDateMilliseconds - this.startDateMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (1000));
        let cal = Math.floor(interval / (1000));
        return (cal < 0) ? 0 : cal;
    }

    /***/
    get ToTalMinutes() {
        //定義をそのまま使用する場合は下記（validDateTimeが仮に存在しないカラムの場合）
        //return this.TimeoutMinutes;
        //開始から終了までの差
        let interval = this.endDateMilliseconds - this.startDateMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (60 * 1000));
        let cal = Math.floor(interval / (60 * 1000));
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの秒を返す*/
    public get RemainingMilliSeconds() {
        let interval = this.endDateMilliseconds - this.nowMilliseconds;
        let cal = Math.floor(interval);
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの秒を返す*/
    public get RemainingSeconds() {
        let interval = this.endDateMilliseconds - this.nowMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / 1000);
        let cal = Math.floor(interval / 1000);
        return (cal < 0) ? 0 : cal;
    }

    /**制限時間までの分を返す*/
    public get RemainingMinutes() {
        let interval = this.endDateMilliseconds - this.nowMilliseconds;
        //let cal = Math.floor(Math.abs(interval) / (60 * 1000));
        let cal = Math.floor(interval / (60 * 1000));
        return (cal < 0) ? 0 : cal;
    }



    /**
     * 
     * @param selector
     * @param limit
     * @param _options
     */
    constructor(selector: any, startDateTime, endDateTime, _options?: ProgressTimerOptions) {

        var options: ProgressBarOptions = {};
        //options.max = limit || 0;
        if (!_.isNil(_options?.height)) { options.height = _options.height; }
        if (!_.isNil(_options?.width)) { options.width = _options.width; }
        options.max = 0;
        options.now = 0;
        options.showInnerLabel = false;

        super(selector, options);


        this.startDateTime = startDateTime;
        this.endDateTime = endDateTime;
        this.max = this.ToTalSecond;
        ////一旦100に
        //this.current = this.ToTalSecond;
        //////一旦0に
        ////this.current = 0;

        //0はまずいのでfalsyとする
        this.interval = (_options?.interval) ? _options.interval : 1000;
        if (!_.isNil(_options?.onTick)) { this.onTick = _options.onTick; }
        if (!_.isNil(_options?.onAt25)) { this.onAt25 = _options.onAt25; }
        if (!_.isNil(_options?.onAt50)) { this.onAt50 = _options.onAt50; }
        if (!_.isNil(_options?.onAt75)) { this.onAt75 = _options.onAt75; }
        if (!_.isNil(_options?.onTimeOut)) { this.onTimeOut = _options.onTimeOut; }
    }

    /**
     * 
     * @param at 開始
     */
    start() {
        //開始しない
        if (this.RemainingSeconds <= 0) {
            this.destroy();
            return this;
        }

        this.current = this.RemainingSeconds;
        this.nIntervId = setInterval(this.tick.bind(this), this.interval);
        //console.log('start:nIntervId :' + this.nIntervId);
        return this;
    }

    /** */
    stop() {
        //console.log('timeout:nIntervId :' + this.nIntervId);
        clearInterval(this.nIntervId);
        return this;
    }

    /** */
    destroy() {
        this.onTick = null;
        this.onTickedLabel = null;
        this.onTimeOut = null;
        this.stop();
        this.container?.empty();
        return this;
    }

    /** */
    private timeOut() {
        this.stop();

        if (this.onTimeOut) {
            this.onTimeOut();
        }
        return this;
    }

    /**
     * 
     * @param n
     */
    tick() {

        //時間補正をかねて、都度計算しなおす
        //var nextTick = Math.floor(this.current - (this.interval / 1000));
        var nextTick = this.RemainingSeconds;
        if (this.onTick) {
            //var labelText = this.onTick(nextTick);
            //this.setLabelFunc = (c): string => { return labelText; }
            var retTick = this.onTick(nextTick);
            //var retTick = this.onTick.call(this, nextTick);
            if (!_.isNil(retTick)) {
                //補正値があればそれを使用
                nextTick = retTick;
            }
        }

        this.current = nextTick;
        //console.log('current : ' + this.current);
        //計算した結果と生で比較した場合とで若干誤差が生じる為、生データで判断する
        //if (this.current <= 0) {RemainingMilliSeconds
        if (this.current <= 0) {
            //console.log('this.current <= 0 : ' + this.current);
            this.timeOut();
            //this.timeOut.call(this);
        }
        this.appearance();
        return this;
    }

    /** */
    appearance() {

        this.progressBar.removeClass('bg-danger bg-warning bg-info bg-succsess');
        if (this.parRemaining < 25) { // less than 25 %
            this.progressBar.addClass('progress-bar bg-danger');
            if (this.onAt25) { this.onAt25(); }
        } else if (this.parRemaining < 50) { // less than 50 % (and more than 25 %)
            this.progressBar.addClass('progress-bar bg-warning');
            if (this.onAt50) { this.onAt50(); }
        } else if (this.parRemaining < 75) { // less than 75 % (and more than 50 %)
            this.progressBar.addClass('progress-bar bg-info');
            if (this.onAt75) { this.onAt75(); }
        } else {
            this.progressBar.addClass('progress-bar bg-succsess');
        }
    }

};
